import { Tabs, Input } from 'components/elements'
import { useRouter } from 'next/router'
import { useState, useMemo } from 'react'
// import { useDebounce } from 'components/helpers/utils'

import * as S from './Search.styles'
import SearchArticles from './assets/SearchGCSE'
import SearchPeople from './assets/SearchPeople'
import SearchTopics from './assets/SearchTopics'

const defaultProps = {}
const propTypes = {}

const tabsMap = {
  articles: SearchArticles,
  people: SearchPeople,
  topics: SearchTopics,
  empty: () => <div>empty</div>,
}

export const Search = () => {
  const router = useRouter()
  const [pageMap, setPageMap] = useState({})
  const [inputValue, setInputValue] = useState('')
  // const debouncedSearchTerm = useDebounce(inputValue, 500)

  const { t: tab = 'articles', q = '' } = router.query
  const crrPage = pageMap[tab] || 1

  const handleChange = newValue => {
    if (newValue === 'articles') {
      window.location = `/search?t=articles&q=${q}`
    } else {
      window?.scroll(0, 0)
      router.push(`/search?t=${newValue}&q=${q}`, undefined, {
        shallow: true,
      })
    }
  }

  const changePage = page => {
    setPageMap(p => ({
      ...p,
      [tab]: page,
    }))
  }

  const tabs = useMemo(() => {
    return [
      { label: 'Articles', value: 'articles' },
      { label: 'People', value: 'people' },
      { label: 'Topics', value: 'topics' },
    ]
  }, [])

  const Component = useMemo(() => tabsMap[tab] || tabsMap.empty, [tab])

  const config = {
    q,
    changePage,
    crrPage,
  }

  return (
    <S.Container>
      <S.Content>
        <Input
          placeholder="Search"
          value={inputValue}
          variant="outlined"
          color="primary"
          onChange={e => setInputValue(e.target.value)}
          onKeyPress={ev => {
            if (ev.key === 'Enter') {
              setPageMap({})
              if (tab === 'articles') {
                window.location = `/search?t=articles&q=${inputValue}`
              } else {
                router.push(`/search?t=${tab}&q=${inputValue}`, undefined, {
                  shallow: true,
                })
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <S.SearchIcon
                onClick={() => {
                  if (tab === 'articles') {
                    window.location = `/search?t=articles&q=${inputValue}`
                  } else {
                    router.push(`/search?t=${tab}&q=${inputValue}`, undefined, {
                      shallow: true,
                    })
                  }
                }}
              />
            ),
          }}
        />
      </S.Content>
      <S.Content>
        {!q && tab === 'articles' && (
          <S.Header>Please enter a search term</S.Header>
        )}
        {(tab !== 'articles' || (q && tab === 'articles')) && (
          <S.Header>
            {q ? (
              <>
                <span>Results for&nbsp;</span>
                {q}
              </>
            ) : (
              <div>Top results</div>
            )}
          </S.Header>
        )}
        <S.TabsContainer>
          <Tabs.TabsHeader>
            <Tabs
              key={tab}
              options={tabs}
              defaultValue={tab}
              onChange={handleChange}
            />
          </Tabs.TabsHeader>
          <S.TabsContent>
            {tab === 'articles' && !router.query?.q ? (
              <S.EmptyContainer>
                Enter a search term to find articles
              </S.EmptyContainer>
            ) : (
              <Component {...config} key={q} />
            )}
          </S.TabsContent>
        </S.TabsContainer>
      </S.Content>
    </S.Container>
  )
}

Search.defaultProps = defaultProps
Search.propTypes = propTypes

export default Search
